import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { WHATSAPP_URL } from '../data/content';
export function FinalCta() {
  return <section className="relative isolate overflow-hidden bg-ink py-28 text-cream lg:py-36" data-id="element-198" data-mp="19ez2ffcjrc38">
      <img src="https://cdn.magicpatterns.com/patterns/generated-images/eacfc078-2886-43e0-8263-a1825ff49b52.jpg" alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover" data-id="element-199" data-mp="15ddhr7trttih" />
      <div className="absolute inset-0 bg-ink/80" aria-hidden="true" data-id="element-200" data-mp="1eetpt8x45jjj" />

      <div className="relative mx-auto max-w-content px-6 text-center lg:px-10" data-id="element-201" data-mp="1t2omt1i5ma2f">
        <h2 className="mx-auto max-w-3xl font-serif text-[2.3rem] font-light leading-[1.08] sm:text-[3.2rem]" data-id="element-202" data-mp="1t4r8j9c9xh1c">
          ¿Quieres saber cuánto costaría renovar tu suelo?
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-[15px] leading-relaxed text-cream/70" data-id="element-203" data-mp="223wayqqyhuis">
          Calcula una estimación en 60 segundos o escríbenos por WhatsApp para revisar tu caso.
        </p>
        <div className="mt-11 flex flex-col items-center justify-center gap-3 sm:flex-row" data-id="element-204" data-mp="n7fcjgdxim9c">
          <CtaButton href="#calculadora" variant="cream" data-id="element-205" data-mp="s57e724dlmqq">
            Calcular mi suelo ahora
          </CtaButton>
          <CtaButton href={WHATSAPP_URL} variant="light" external icon={<MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-207" data-mp="120inv60xg3rm" />} data-id="element-206" data-mp="x5v7jug2ufo4">
            Hablar por WhatsApp
          </CtaButton>
        </div>
        <p className="mt-6 text-[12px] text-cream/55" data-id="element-208" data-mp="1b2i6u3vi5hx7">
          Sin compromiso. Te orientamos antes de venderte nada.
        </p>
      </div>
    </section>;
}